<template>
  <router-view />
</template>

<script>
export default {
  name: "trainingMview"
};
</script>
